/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import TestimonialExample from '../examples/Testimonial';
const TestimonialExampleSource = require('!!raw-loader!../examples/Testimonial');
export default function TestimonialPage() {
    return (<div>
            <Helmet title="Testimonial"/>
            <h3>Testimonial</h3>
            <hr />
            <div className="docs-example">
                <TestimonialExample />
            </div>
            <pre>
                <PrismCode className="language-jsx">{TestimonialExampleSource}</PrismCode>
            </pre>
        </div>);
}
